import { styled, Typography } from '@mui/material';

export const ZoneWrapper = styled('div')`
  border: ${({ theme }) => `2px dashed ${theme.palette.primary.grey}`};
  width: 100%;
  margin-top: 16px;
  border-radius: 12px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 1023px) {
    padding: 20px 16px;
  }
`;

export const OptionRow = styled('label')`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  width: 100%;
  justify-content: center;
  padding: 8px 0;
`;

export const DisabledOptionRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  opacity: 0.45;
  width: 100%;
  justify-content: center;
  padding: 8px 0;
`;

export const OptionLabel = styled(Typography)`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.p080};

  @media (max-width: 1023px) {
    font-size: 14px;
  }
`;

export const DividerText = styled(Typography)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.primary.p040};
`;

export const HiddenInput = styled('input')`
  display: none;
`;

export const ActiveOptionRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  width: 100%;
  justify-content: center;
  padding: 8px 0;

  &:hover {
    opacity: 0.8;
  }
`;
